import moment from 'moment';

export default {
  methods: {
    getAccommodationDateRange() {
      const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
      const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

      let start = null;
      let end = null;

      if (!confirmed.length) {
        // Check from adding
        if (!this.$store.state.cart.addToOrder || !this.$store.state.cart.addToOrder.dateStart) {
          return false;
        }

        start = moment(this.$store.state.cart.addToOrder.dateStart);
        end = moment(this.$store.state.cart.addToOrder.dateEnd);
      } else {
        // Check from confirmed accomodations
        start = moment.min(confirmed.map(accomodation => moment(accomodation.period.date_arrival)));
        end = moment.max(confirmed.map(accomodation => moment(accomodation.period.date_departure)));
      }

      return { start, end };
    },
    getAccommodationDateRangeAsDates() {
      const range = this.getAccommodationDateRange();

      if (!range) {
        return false;
      }

      const loopStart = moment(range.start).toDate();
      const end = moment(range.end).toDate();

      let current = loopStart;

      const newArray = [];

      while (current <= end) {
        current = moment(current);
        if (this.SITE_CONFIG.season.winter.closed.indexOf(current.format('YYYY-MM-DD')) === -1) {
          newArray.push(current.format('YYYY-MM-DD'));
        }
        current = current.add(1, 'days').toDate();
      }

      return newArray;
    },
    getDatesWithAccommodationRestrictions($dates) {
      const range = this.getAccommodationDateRange();
      let newDates = $dates;

      // Okay, we have $dates.
      // They need to be filtered so only those in this.dates the range are left
      if (range !== false) {
        const allowedDates = this.getAccommodationDateRangeAsDates();
        newDates = newDates.filter((date) => {
          const m = moment(date, 'YYYY-MM-DD');
          return allowedDates.find(allowedDate => moment(allowedDate).isSame(m, 'day'));
        });
      }

      return newDates;
    },
    /**
     * Returns:
     * - true, if within range or no range identified
     * - false, if no start or end date provided
     * - -1, if start date is before range
     * - -2, if start date is after range
     * - -3, if end date is after range
     */
    areDatesWithinAccommodationRange($start, $end) {
      const range = this.getAccommodationDateRange();

      if (!range) {
        return true;
      }

      const { start, end } = range;

      if (!$start || !$end) {
        return false;
      }

      const startDate = moment($start);
      const endDate = moment($end);

      // First, check if the school starts before the arrival
      if (startDate.isBefore(start, 'day')) {
        return -1;
      }

      if (startDate.isAfter(end, 'day')) {
        return -2;
      }

      // Then, check if the school ends after the departure
      if (endDate.isAfter(end, 'day')) {
        return -3;
      }

      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/restrictions.js